export enum LocalStorageKey {
    CURRENT_PATH = 'current-absolute-path'
}